<template>
  <div>
    <div class="mb-4" v-for="field in app" v-bind:key="field.name">
      <v-card class="mx-auto mb-4" outlined v-if="showField(field.name)">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">
              <v-text-field
                v-if="activeEditFieldName != field.name"
                v-model="field.value"
                single-line
                full-width
                hide-details
                readonly
              ></v-text-field>
              <v-text-field
                v-if="activeEditFieldName == field.name"
                v-model="field.value"
              ></v-text-field>
            </v-list-item-title>
            <v-list-item-subtitle class="pl-4">
              {{ field.name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions>
          <v-btn
            class="edit-button"
            text
            v-on:click="onEditClick(field.name)"
            v-if="activeEditFieldName != field.name"
            >Edit</v-btn
          >
          <v-btn
            class="edit-button"
            text
            v-on:click="onSubmit()"
            v-if="activeEditFieldName == field.name"
            >Submit</v-btn
          >
          <v-btn
            class="edit-button"
            text
            v-on:click="onCancel()"
            v-if="activeEditFieldName == field.name"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
    <v-text-field
      class="search-box"
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      hide-details
    ></v-text-field>
    <menu-item-draggable
      v-model="menuList"
      @input="onMenuTreeInput"
      @update="onUpdate"
      :search="search"
    ></menu-item-draggable>
  </div>
</template>

<script>
import MenuItemDraggable from '../components/MenuItemsTree/MenuItemsDraggable'

export default {
  components: {
    MenuItemDraggable
  },
  data() {
    return {
      fields: ['Name', 'Authentication key'],
      activeEditFieldName: '',
      localMenuList: [],
      search: ''
    }
  },
  created: function() {
    this.$store
      .dispatch('ClientAppStore/selectClientApp', this.$route.params.appId, {
        root: true
      })
      .then(() => {
        this.$store
          .dispatch('MenuItemsStore/fetchMenuItems', { root: true })
          .then(() => {
            this.app.id.value = this.$store.state.ClientAppStore.selectedApp.id
            this.app.name.value = this.$store.state.ClientAppStore.selectedApp.name
            this.app.app_key.value = this.$store.state.ClientAppStore.selectedApp.app_key
            this.menuList = this.$store.state.MenuItemsStore.menuItems
          })
      })
  },
  computed: {
    app: function() {
      return {
        id: {
          value: this.$store.state.ClientAppStore.selectedApp.id,
          name: 'ID'
        },
        name: {
          value: this.$store.state.ClientAppStore.selectedApp.name,
          name: 'Name'
        },
        app_key: {
          value: this.$store.state.ClientAppStore.selectedApp.app_key,
          name: 'Authentication key'
        }
      }
    },
    menuList: {
      get: function() {
        // return this.$store.state.MenuItemsStore.menuItems;
        return this.localMenuList
      },
      set: function(newValue) {
        // this.$store.dispatch(
        //   "MenuItemsStore/updateMenuItemsChildren",
        //   newValue
        // );
        this.localMenuList = newValue
      }
    }
  },
  methods: {
    onSubmit: function() {
      console.log(this.app)
      this.$store.dispatch('ClientAppStore/updateClientApp', {
        id: this.app.id.value,
        name: this.app.name.value,
        app_key: this.app.app_key.value
      })
      this.activeEditFieldName = ''
    },
    showField: function(field) {
      return this.fields.find(function(element) {
        return element == field
      })
    },
    onEditClick: function(fieldName) {
      this.activeEditFieldName = fieldName
    },
    onCancel: function() {
      this.activeEditFieldName = ''
    },
    onMenuTreeInput(value) {
      this.$store.dispatch('MenuItemsStore/updateMenuItemsChildren', value)
    },
    onUpdate(value) {
      this.$store.dispatch('MenuItemsStore/fetchMenuItems').then(() => {
        console.log('UPDATE')
        this.menuList = this.$store.state.MenuItemsStore.menuItems
      })
    }
  }
}
</script>

<style scoped>
.edit-button {
  color: #fac020;
}
.search-box {
  margin: 0.5rem;
  margin-bottom: 2;
  max-width: 25rem;
  color: #fac020;
  padding-bottom: 1rem;
}
</style>
